module.exports = __webpack_public_path__ + "static/media/autoin.b3117202.png";